import React,{useState}from "react";

const InvoiceBillTo = () => {
    const [showAdditionalForm, setShowAdditionalForm] = useState(false);

    const toggleAdditionalForm = (event) => {
      const { checked } = event.target;
      setShowAdditionalForm(checked);
    };
  
  return (
    <div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightAddress"
        aria-labelledby="offcanvasRightAddress"
        style={{ minWidth: "30%", maxWidth: "30%" }}
      >
        <div className="offcanvas-header bg-primary">
          <h4 id="offcanvasInvBillTo" className="text-white">
          Address Form
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
        <form>
            <div className="mb-3">
              <label className="form-label">Street</label>
              <textarea className="form-control"></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label">City</label>
              <input type="text" className="form-control" />
            </div>
            <div className="mb-3">
              <label className="form-label">State</label>
              <input type="text" className="form-control" />
            </div>
            <div className="mb-3">
              <label className="form-label">Zip Code</label>
              <input type="text" className="form-control" />
            </div>
            <div className="mb-3">
              <label className="form-label">Country</label>
              <select className="form-select">
                <option>Nothing selected</option>
                <option>USA</option>
                <option>Canada</option>
                <option>UK</option>
              </select>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="shippingAddress"
                onChange={toggleAdditionalForm}
              />
              <label className="form-check-label" htmlFor="shippingAddress">
                Shipping Address
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="showDetails"
                onChange={toggleAdditionalForm}
              />
              <label className="form-check-label" htmlFor="showDetails">
                Show shipping details in estimate
              </label>
            </div>

            {/* Hidden Additional Form */}
            {showAdditionalForm && (
              <div className="mt-3">
                <h6>Shipping Details</h6>
                <div className="mb-3">
                  <label className="form-label">Street</label>
                  <textarea className="form-control"></textarea>
                </div>
                <div className="mb-3">
                  <label className="form-label">City</label>
                  <input type="text" className="form-control" />
                </div>
                <div className="mb-3">
              <label className="form-label">State</label>
              <input type="text" className="form-control" />
            </div>
            <div className="mb-3">
              <label className="form-label">Zip Code</label>
              <input type="text" className="form-control" />
            </div>
            <div className="mb-3">
              <label className="form-label">Country</label>
              <select className="form-select">
                <option>Nothing selected</option>
                <option>USA</option>
                <option>Canada</option>
                <option>UK</option>
              </select>
            </div>
              </div>
            )}
          </form>

        </div>
      </div>
    </div>
  );
};

export default InvoiceBillTo;